function bitmaskWordBit(width: number, x: number, y: number) {
  const i = y * width + x;
  const w = i >>> 5; // word index = floor(i / 32)
  const b = i & 31; // bit index  = i % 32
  return { i, w, b };
}

export function bitmaskGet(
  mask: Uint32Array,
  width: number,
  x: number,
  y: number
): boolean {
  const { i, w, b } = bitmaskWordBit(width, x, y);
  if (i < 0 || i >= mask.length * 32) return false;
  return ((mask[w] >>> b) & 1) === 1;
}

export function bitmaskSet(
  mask: Uint32Array,
  width: number,
  x: number,
  y: number
): void {
  const { i, w, b } = bitmaskWordBit(width, x, y);
  if (i < 0 || i >= mask.length * 32) return;
  mask[w] |= 1 << b;
}

export function bitmaskClear(
  mask: Uint32Array,
  width: number,
  x: number,
  y: number
): void {
  const { i, w, b } = bitmaskWordBit(width, x, y);
  if (i < 0 || i >= mask.length * 32) return;
  mask[w] &= ~(1 << b);
}

export function bitmaskCreate(w: number, h: number): Uint32Array {
  // Allocate enough 32-bit words to cover w*h bits
  const bitCount = w * h;
  const wordCount = (bitCount + 31) >>> 5; // ceil(bitCount / 32)
  return new Uint32Array(wordCount);
}
